import * as React from "react";
const FilterIcon = ({width = "24px", height = "24px", color = "#000000", ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    style={{
      enableBackground: "new 0 0 24 24",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill={color}
        d="M9.8,10.8c-1.8,0-3.2-1.5-3.2-3.2S8,4.2,9.8,4.2S13,5.7,13,7.5S11.5,10.8,9.8,10.8z M9.8,6.2 c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2S11,8.2,11,7.5S10.4,6.2,9.8,6.2z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M15.8,19.8c-1.8,0-3.2-1.5-3.2-3.2s1.5-3.2,3.2-3.2s3.2,1.5,3.2,3.2S17.5,19.8,15.8,19.8z M15.8,15.2 c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S16.4,15.2,15.8,15.2z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M20.2,8.5H12c-0.6,0-1-0.4-1-1s0.4-1,1-1h8.2c0.6,0,1,0.4,1,1S20.8,8.5,20.2,8.5z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M7.5,8.5H3.8c-0.6,0-1-0.4-1-1s0.4-1,1-1h3.8c0.6,0,1,0.4,1,1S8.1,8.5,7.5,8.5z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M20.2,17.5H18c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.2c0.6,0,1,0.4,1,1S20.8,17.5,20.2,17.5z"
      />
    </g>
    <g>
      <path
        fill={color}
        d="M13.5,17.5H3.8c-0.6,0-1-0.4-1-1s0.4-1,1-1h9.8c0.6,0,1,0.4,1,1S14.1,17.5,13.5,17.5z"
      />
    </g>
  </svg>
);
export default FilterIcon;
